
import { Component, Prop, Vue } from 'vue-property-decorator'

import { accessibleTicketGroupColor } from '@tix/themes/helpers'

import { getAccessibilityType } from '@/helpers/TicketGroupHelpers'

import type { AccessibilityType, LinkedTG } from '../../api/types/processedEntities'
import { getTicketGroupColor } from '../../helpers/TicketGroupsColors'

@Component({ name: 'TicketGroupSeatBadge' })
export default class extends Vue {
  @Prop({ required: true })
  ticketGroup: LinkedTG

  readonly iconsMap = {
    wheelchair: 'WheelchairIcon',
    companion: 'CompanionIcon',
    'semi-ambulatory': 'AisleTransferIcon',
  }

  get isAccessible(): boolean {
    return this.ticketGroup.isAccessible ?? false
  }

  get accessibilityType(): AccessibilityType | undefined {
    return getAccessibilityType(this.ticketGroup)
  }

  get style(): Dict<string> {
    return {
      '--tg-color': this.isAccessible ? accessibleTicketGroupColor : getTicketGroupColor(this.ticketGroup)!,
    }
  }
}
